<template>
  <span
    class="badge badge-sm uppercase"
    :class="badgeClass"
  >
    {{ label }}
  </span>
</template>

<script>
export default {
  name: 'PermissionBadge',
  props: {
    action: {
      type: String,
      required: true
    }
  },
  computed: {
    label () {
      return this.action
    },
    badgeClass () {
      if (this.action === 'admin') return 'badge-error'
      if (this.action === 'edit') return 'badge-warning'
      if (this.action === 'send') return 'badge-accent'
      if (this.action === 'sign') return 'badge-secondary'

      return 'badge-neutral'
    }
  }
}
</script>

